
/**
 * Component customStyleBoxSA
 * Utilized for creating custom styles
 * @param color
 * @returns {{padding: string, margin: string, backgroundColor, borderRadius: string, color: string, width: string}}
 */
export const customStyleBoxSA = (color) => {
	return {
		width: '64px',
		margin: '2px 16px 0 0',
		padding: '16px 0',
		borderRadius: '12px',
		backgroundColor: color,
		color: 'white'
	}
};

/**
 * Component widthHeight
 * Utilized for creating custom styles
 * @param width
 * @param height
 * @returns {{width, height}}
 */
export const widthHeight = (width, height) => {
	return {
		width: width,
		minHeight: height
	}
};

/**
 * Component marginTop
 * Utilized for creating custom styles
 * @param margin
 * @returns {{marginTop}}
 */
export const marginTop = (margin) => {
	return {
		marginTop: margin
	}
};

export function resolveRoles(roles, adminRoles) {
	let retVal = [];
	if (roles.length > 0) {
		for (let item of roles) {
			for (let admin of adminRoles) {
				if (admin.roleCode === item.role) {
					retVal.push({
						label: getRoleNameByRoleCode(item.role),
						value: admin.roleCode
					})
				}
			}
		}
	}
	return retVal;
};

export function getRoleNameByRoleCode(role) {
	if (role.toLowerCase() === 'selfservicepartneradmin'.toLowerCase()) {
		return 'Partner admin'
	}
	if (role.toLowerCase() === 'rsAdpAccountsReceivable'.toLowerCase()) {
		return 'Accounts receivable'
	}
	if (role.toLowerCase() === 'rsAdpBillingAdmin'.toLowerCase()) {
		return 'Billing admin'
	}
	if (role.toLowerCase() === 'selfservicetemplateadmin'.toLowerCase()) {
		return 'Template admin'
	}
	if (role.toLowerCase() === 'selfservicesuperuser'.toLowerCase()) {
		return 'Super admin'
	}
	return 'User';
};

export function getRoleName(role, adminRoles) {
	let name = "NA";
	let refRoleName = "NA";

	for (let adminRole of adminRoles) {
		if (adminRole.roleId === role.roleId) {
			refRoleName = adminRole.roleName;
		}
	}

	switch (refRoleName) {
		case "Self Service Partner Admin":
			name = 'Partner admin';
			break;
		case "Self Service Super User":
			name = 'Super admin';
			break;
		case "Rev Share ADP Accounts Receivable":
			name = 'Accounts receivable';
			break;
		case "Rev Share ADP Billing Admin":
			name = 'Billing admin';
			break;
		case "Self Service Template Admin":
			name = 'Template admin';
			break;
		default:
			name = 'User';
			break;
	}
	return name;
};

// converting first letter to uppercase
export function capitalizeFirstLetter(str) {
	const capitalized = str
		.toLowerCase()
		.split(' ')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
	return capitalized;
};

export function getFullName(firstName, lastName) {
	return `${capitalizeFirstLetter(firstName || 'NA')} ${capitalizeFirstLetter(lastName || 'NA')}`;
};

export function mapClassToStyles(roleType) {
	let style = {};
	switch (roleType) {
		case "SA":
			style = { backgroundColor: "#3bbeb9" };
			break;
		case "PA":
			style = { backgroundColor: "#fb807a" };
			break;
		case "TA":
			style = { backgroundColor: "#f9ac84" };
			break;
		case "BA":
			style = { backgroundColor: "#8f7dc5" };
			break;
		case "AR":
			style = { backgroundColor: "#476bc3" };
			break;
		default:
			break;
	}
	return style;
};

export function getRoleInitial(role, adminRoles) {
	let initial = "NA";
	// eslint-disable-next-line array-callback-return
	adminRoles.filter(adminRole => {
		if (adminRole.roleId === role.roleId && adminRole.roleName) {
			initial = adminRole.roleName;
		}
	});

	switch (initial) {
		case "Self Service Partner Admin":
			initial = 'PA';
			break;
		case "Self Service Super User":
			initial = 'SA';
			break;
		case "Rev Share ADP Accounts Receivable":
			initial = 'AR';
			break;
		case "Rev Share ADP Billing Admin":
			initial = 'BA';
			break;
		case "Self Service Template Admin":
			initial = 'TA';
			break;
		default:
			initial = 'NA';
			break;
	}
	return initial;
};

export async function memberContainsAdminRoles(memberRoles, rolesAdmin) {
	let foundAtLeastOne = false;
	let acceptedRoles = [];

	if (memberRoles.length > 0) {
		for (let index in memberRoles) {
			for (let adminRole of rolesAdmin) {
				if (memberRoles[index].roleId === adminRole.roleId) {
					acceptedRoles.push(memberRoles[index]);
					foundAtLeastOne = true;
				}
			}
		}
		return {
			foundAtLeastOne: foundAtLeastOne,
			acceptedRoles: acceptedRoles
		};
	}
	return {
		foundAtLeastOne: foundAtLeastOne,
		acceptedRoles: memberRoles
	};
};

export const roleDescriptions = [
	{
		title: 'Super admin',
		description: 'This role has the most access and can assign super admin, client admin and template admin access to others.',
		initials: 'SA',
		backgroundColor: '#3bbeb9',
		roleCode: 'selfservicesuperuser'
	} ,
   {
		title: 'Partner admin',
		description: 'This role has access to view and manage partner orgs and partner projects. A partner admin can assign partner admin access \n' +
			'to others.',
		initials: 'PA',
		backgroundColor: '#fb807a',
		roleCode: 'selfservicepartneradmin'
	},
	{
		title: 'Template admin',
		description: 'This role has access to template manager tab. This admin can create new templates and manage existing ones.',
		initials: 'TA',
		backgroundColor: '#f9ac84',
		roleCode: 'selfservicetemplateadmin'
	},
	{
		title: 'Billing admin',
		description: 'This role has access to the revenue share tab. This admin can approve offline referral sales and send final counts to ADP accounting.',
		initials: 'BA',
		backgroundColor: '#8f7dc5',
		roleCode: 'rsAdpBillingAdmin'
	},
	{
		title: 'Accounts receivable',
		description: 'This role has access to the revenue share tab. This role is responsible for reviewing monthly changes to offline referral sales by Marketplace partners.',
		initials: 'AR',
		backgroundColor: '#476bc3',
		roleCode: 'rsAdpAccountsReceivable'
	}
];

export function canSessionMemberEdit(role, adminRoles, loggedInRoles) {
	let retVal = true;
	if (loggedInRoles) {
		for (let roleItem of loggedInRoles) {
			if (roleItem.role === "selfservicepartneradmin" && role.roleCode === "selfservicepartneradmin") {
				retVal = false;
			}
			if (roleItem.role === "rsAdpAccountsReceivable" && role.roleCode === "rsAdpAccountsReceivable") {
				retVal = false;
			}
			if (roleItem.role === "rsAdpBillingAdmin" && role.roleCode === "rsAdpBillingAdmin") {
				retVal = false;
			}
			if (roleItem.role === "selfservicetemplateadmin" && role.roleCode === "selfservicetemplateadmin") {
				retVal = false;
			}
			if (roleItem.role === "selfservicesuperuser" && role.roleCode === "selfservicesuperuser") {
				retVal = false;
			}
		}
	}
	return retVal;
};

export function getAvailableRoles(roles, availableRoles) {
	roles.forEach(role => {
		availableRoles = availableRoles.filter(function(item) {
			return item.roleId !== role.roleId
		})
	});
	return availableRoles;
};
